import { Button, Heading, Stepper } from '@tmov/design-system';
import { SpinnerMedium } from '@tmov/design-system/icons';
import { Form, notification } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import apiShipper from '../../../services/apiShipper';
import Cotacao from './Steps/Cotacao';
import DadosGerais from './Steps/DadosGerais';
import Transporte from './Steps/Transporte';
import { CadastroForm, Container, FormControls, Header } from './styles';

const steps = {
  1: { title: 'Dados Gerais' },
  2: { title: 'Cotação' },
  3: { title: 'Transporte' },
};

export default function CadastroCotacao() {
  const history = useHistory();

  const [form] = Form.useForm();
  const [submitLoading, setSubmitLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);

  const handleValidateFields = async () => {
    try {
      await form.validateFields();
      return true;
    } catch ({ errorFields }) {
      const valid = errorFields.length === 0;
      return valid;
    }
  };

  const handleReturn = () => {
    setCurrentStep(prev => {
      const newStep = prev - 1;

      if (newStep >= 1) {
        return newStep;
      }
      history.goBack();
      return prev;
    });
  };

  const handleAdvance = async () => {
    const isNext = await handleValidateFields();
    if (!isNext) return;
    setCurrentStep(prev => {
      const newStep = prev + 1;

      if (newStep <= 3) {
        return newStep;
      }
      return prev;
    });
  };

  const handleSubmit = async () => {
    setSubmitLoading(true);
    try {
      const fieldsVlues = form.getFieldsValue(true);

      await apiShipper.post('/cotacoes', {
        cliente_pagador_tmov_id: fieldsVlues.clientePagador.id,
        produto_tmov_id: fieldsVlues.produto.id,
        especie_tmov_id: fieldsVlues.especie.id,
        volume: Number(fieldsVlues.volume.replace(',', '.')),
        cadencia: Number(fieldsVlues.cadencia.replace(',', '.')),
        cidade_origem_tmov_id: fieldsVlues.cidadeOrigem.id,
        cidade_destino_tmov_id: fieldsVlues.cidadeDestino.id,
        inicio_carregamento: fieldsVlues.inicioCarregamento.utc().format(),
        fim_carregamento: fieldsVlues.fimCarregamento.utc().format(),
        tipo_cadencia: Number(fieldsVlues.tipoCadencia),
        tipo_pagamento: Number(fieldsVlues.tipoPagamento),
        incremento_minimo: Number(fieldsVlues.incrementoMin.replace(',', '.')),
        tipos_carretas: fieldsVlues.tiposCarretas
          .filter(tipoCarreta => tipoCarreta.checked)
          .map(tipoCarreta => tipoCarreta.id),
        tipos_cavalos: fieldsVlues.tiposCavalos
          .filter(tipoCavalo => tipoCavalo.checked)
          .map(tipoCavalo => tipoCavalo.id),
        parceiros: fieldsVlues.transportadoras
          .filter(transportadora => transportadora.checked)
          .map(transportadora => transportadora.id),
        valor_inicial: Number(fieldsVlues.valorInicial.replace(',', '.')),
        periodo_inicio: fieldsVlues.dataInicioCotacao
          .hour(fieldsVlues.horarioInicioCotacao.hour() - 3)
          .minute(fieldsVlues.horarioInicioCotacao.minute()),
        periodo_fim: fieldsVlues.dataFimCotacao
          .hour(fieldsVlues.horarioFimCotacao.hour() - 3)
          .minute(fieldsVlues.horarioFimCotacao.minute()),
        observacao: fieldsVlues.observacao,
      });
      history.push({
        pathname: '/cotacao/criada',
        state: {
          rota: `${fieldsVlues.cidadeOrigem.value} > ${fieldsVlues.cidadeDestino.value}`,
        },
      });
    } catch ({ response }) {
      const erros = response?.data?.errors;

      let description =
        'Caso o problema persista, entre em contato com nosso suporte.';

      const message =
        response?.data?.message || 'Erro inesperado ao criar Cotação.';

      if (erros) description = erros.join('. ');

      notification.error({
        message,
        description,
      });
    }

    setSubmitLoading(false);
  };

  return (
    <Container>
      <Header>
        <Heading variant="h2">{steps[currentStep].title}</Heading>
      </Header>
      <CadastroForm form={form} size="large" onFinish={handleSubmit}>
        <Stepper current={currentStep}>
          <Stepper.Step title={steps[1].title}>
            <DadosGerais
              setFieldsValue={form.setFieldsValue}
              getFieldsValue={form.getFieldsValue}
            />
          </Stepper.Step>
          <Stepper.Step title={steps[2].title}>
            <Cotacao />
          </Stepper.Step>
          <Stepper.Step title={steps[3].title}>
            <Transporte />
          </Stepper.Step>
        </Stepper>
        <FormControls>
          <Button
            type="button"
            variant="outlined"
            onClick={handleReturn}
            style={{ width: 136 }}
          >
            Voltar
          </Button>
          {currentStep !== 3 ? (
            <Button
              data-testid="advance-button"
              type="button"
              onClick={handleAdvance}
              style={{ width: 136 }}
            >
              Próximo
            </Button>
          ) : (
            <Form.Item>
              <Button
                data-testid="submit-button"
                type="submit"
                style={{ width: 136 }}
              >
                {submitLoading && <SpinnerMedium />}Concluir
              </Button>
            </Form.Item>
          )}
        </FormControls>
      </CadastroForm>
    </Container>
  );
}
